import { BookOpenIcon } from "@heroicons/react/24/outline";

import { Collapsible, Small } from "@fronterahealth/frontera-ui-components";

import { ApiReportTemplateReportTypeChoices } from "@api/graphql/types-and-hooks";
import { StickyNav } from "@pages/Templates/components/StickyNav/StickyNav";
import { ReportTemplateSection } from "@providers/TemplateEditorProvider";

interface StickyNavCollapsibleProps {
  sections: ReportTemplateSection[];
  reportType: ApiReportTemplateReportTypeChoices;
}

export const StickyNavCollapsible: React.FC<StickyNavCollapsibleProps> = ({ sections, reportType }) => {
  return (
    <div className="bg-white rounded-2xl py-4 pl-4 pr-0 border-limestone-100 border w-full">
      <Collapsible
        defaultOpenState={true}
        headerContent={
          <div className="flex space-x-2 items-center">
            <BookOpenIcon className="h-4 w-4 text-text-secondary"></BookOpenIcon>
            <Small displayType="loud" colorType="primary">
              On This Page
            </Small>
          </div>
        }
        headerIsClickable={true}
        bodyContent={
          <div className="p-2 pt-4">
            <StickyNav sections={sections} reportType={reportType} />
          </div>
        }
      />
    </div>
  );
};
